<nav class="navbar">
  <div class="nav-container">
    <button class="menu-toggle mobile-only" (click)="toggleSidebar()" aria-label="Toggle menu">
      <i class="fa fa-bars"></i>
    </button>
    <div class="nav-brand">
      <a class="brand-link" routerLink="/reports" aria-label="Opscribe home">
        <img class="brand-logo" src="/opscribe_logo.png" alt="Opscribe" />
      </a>
    </div>
  </div>
</nav>